/**
 * Look up a value by name in a query-string params object.
 *
 * Falls back to `queryParams.colors` (a JSON-encoded object,
 * single-quote-tolerant) when the named param is absent. This is the
 * legacy "compound colors" param used by some embed snippets.
 *
 * Pure function — takes the params object explicitly so it can be
 * unit-tested without mounting a Vue component.
 */
export const extractParam = (queryParams, paramName) => {
  if (!paramName || !queryParams) return '';

  if (queryParams[paramName]) {
    return queryParams[paramName];
  }

  if (queryParams.colors) {
    try {
      // Replace single quotes with double quotes — historic embed
      // snippets use ?colors={'background':'...','text':'...'} which
      // isn't valid JSON.
      const sanitized = queryParams.colors.replace(/'/g, '"');
      const colors = JSON.parse(sanitized);
      if (colors && colors[paramName]) {
        return colors[paramName];
      }
    } catch (e) {
      // Don't echo the payload — it could be hostile and the host page's
      // devtools shouldn't double as input-handling feedback for an attacker.
      // eslint-disable-next-line no-console
      console.error('Invalid JSON in `colors` query param');
    }
  }

  return '';
};
